<template>
  <div class="pt-4 pb-5">
    <div class="cadastroNaoAssociado">
      <div
        class="d-flex flex-column justify-content-between align-items-stretch"
      >
        <div class="row">
          <div class="col form_padrao">
            <Titulo
              title="Cadastrar novo associado"
              description="Informe os dados necessários para realizar o cadastro."
            />
            <div>
              <FormulateForm
                name="Cadastro"
                v-model="values"
                @submit="salvarRegistro"
              >
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="nomefantasia"
                      label="Nome Comercial"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-3">
                    <FormulateInput
                      type="select"
                      name="codpacote"
                      :options="planos"
                      label="Plano"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-3">
                    <FormulateInput
                      type="select"
                      name="tp_empresa"
                      :options="tipoEmpresa"
                      label="Tipo Empresa"
                      validation="required"
                    />
                  </div>
                </div>
                <FormulateInput
                  type="text"
                  name="nome"
                  label="Razão Social"
                  validation="required"
                />
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="cgccfo"
                      label="CPF/CPNJ"
                      validation="required"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @change="validarCpf($event.target.value)"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="inscrestadual"
                      label="Inscrição Estadual"
                    />
                  </div>
                </div>
                <Endereco ref="enderecoRef" />
                <div class="form-row mt-5">
                  <div class="col">
                    <p class="text-uppercase font-12 fw-600">
                      dados do sócio proprietário
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <FormulateInput
                      type="text"
                      name="contato"
                      label="Nome do Sócio Proprietário"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-4">
                    <FormulateInput
                      type="text"
                      name="cpf"
                      label="CPF"
                      validation="required"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      @change="validarCpf($event.target.value)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="select"
                      name="sexo"
                      :options="tipoSexo"
                      label="Sexo"
                      validation="required"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="date"
                      name="datanascimento"
                      label="Data Nascimento"
                      validation="required"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="celular"
                      label="Celular"
                      validation="required"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                  <div class="col-md-6">
                    <FormulateInput
                      type="text"
                      name="telefone"
                      label="Telefone"
                      v-mask="'(##) ####-####'"
                    />
                  </div>
                </div>
                <FormulateInput
                  type="email"
                  name="email"
                  label="Email"
                  validation="required|email"
                  readonly="readonly"
                />
                <div class="d-flex col-5 mt-5">
                  <button
                    type="submit"
                    class="btn btn-verde p-0"
                    :disabled="loading"
                  >
                    <span
                      class="spinner-grow spinner-grow-sm pr-2"
                      role="status"
                      aria-hidden="true"
                      v-show="loading"
                    ></span>
                    <span v-if="loading">Aguarde</span>
                    <span v-else>Salvar</span>
                  </button>
                </div>
              </FormulateForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          @click="$router.push({ name: 'gerenciarAssociados' })"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </div>
</template>

<script>
import { clearStr, validateCPF } from "../../../helpers";
import Titulo from "@/components/TituloPaginas";
import Endereco from "@/components/cadastro/FormEndereco";
import Botao from "@/components/botoes/Botao";
export default {
  name: "Login",
  components: { Endereco, Titulo, Botao },
  data() {
    return {
      produto: {
        nome: "SPC Consultor",
        id: "spcConsultor",
      },
      breadcrumb: [
        {
          nome: "SPC Consultor",
          id: "spcConsultor",
          produto: "SPC Consultor",
        },
        {
          nome: "Cadastrar Associado",
          id: "cadastrarAssociado",
          produto: "SPC Consultor",
        },
      ],
      tipoEmpresa: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Pessoa Jurídica",
          value: "PJ",
        },
        {
          label: "Associação ou Entidade",
          value: "AE",
        },
        {
          label: "Profissional Liberal",
          value: "PL",
        },
        {
          label: "Autônomo",
          value: "AUT",
        },
        {
          label: "MEI",
          value: "MEI",
        },
      ],
      tipoSexo: [
        {
          label: "Selecione",
          value: "",
        },
        {
          label: "Masculino",
          value: "M",
        },
        {
          label: "Feminino",
          value: "F",
        },
      ],
      planos: [
        {
          label: "Selecione",
          value: "",
        },
      ],
      values: {},
      loading: false,
      error: false,
      aceiteTermo: false,
    };
  },
  methods: {
    validarCpf(cpfStr) {
      var cpf = clearStr(cpfStr);

      const result = validateCPF(cpf);
      if (!result) {
        this.invalidCpf = true;
        this.$formulate.handle(
          {
            inputErrors: { cpf: "CPF Inválido!" },
            hasErrors: { cpf: true },
          },
          "Cadastro"
        );
      } else {
        this.invalidCpf = false;
        this.$formulate.handle({ inputErrors: { cpf: null } }, "Cadastro");
      }
    },
    async salvarRegistro() {
      this.loading = true;
      var dadosForm = Object.assign({}, this.values);

      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }

      dadosForm.cgccfo = clearStr(dadosForm.cgccfo);
      dadosForm.cep = clearStr(dadosForm.cep);
      dadosForm.telefone = dadosForm.telefone
        ? clearStr(dadosForm.telefone)
        : "";
      dadosForm.celular = clearStr(dadosForm.celular);
      dadosForm.cpf = clearStr(dadosForm.cpf);

      if (!dadosForm.inscrestadual) {
        dadosForm.inscrestadual = "ISENTO";
      }

      const valuesFixos = {
        codcoligada: 0,
        formapgto: "C",
        codcfo: "-1",
        codcoltcf: "1",
        ativo: 0,
        pagrec: 3,
        pessoafisoujur:
          dadosForm.tp_empresa == "PL" || dadosForm.tp_empresa == "AUT"
            ? "f"
            : "j",
        IPORIGEM: sessionStorage.ip,
        codtcf: "000011",
        CNPJ: dadosForm.cgccfo,
        codetd: dadosForm.estado,
      };

      if (dadosForm.numero) {
        dadosForm.numero = parseInt(dadosForm.numero);
      }
      if (dadosForm.celular) {
        dadosForm.celular = parseInt(dadosForm.celular.substr(2));
      }
      /*if (dadosForm.cidade) {
        dadosForm.codmunicipio = dadosForm.cidade;
      }*/

      const dados = { ...valuesFixos, ...dadosForm };

      await this.$http
        .post("api/Consultor/CadastrarAssociado", dados)
        .then((response) => {
          if (response.data.mensagem) {
            this.$toast.open({
              message: "Cadastro realizado com sucesso.",
              type: "success",
              duration: 4000,
            });
            localStorage.setItem(
              "associadoSelecionado",
              response.data.codSocio
            );
            this.$router.push({ name: "consultorArquivos" });
          } else {
            this.loading = false;
            this.$toast.open({
              message: response.data.mensagem,
              type: "error",
              duration: 4000,
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error.response.data.mensagem,
            type: "error",
            duration: 4000,
          });
        });
      this.error = false;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.values.email = localStorage.getItem("associadoSelecionado");

    // this.$http.get("/api/Consultor/ConsultarPacotes").then((response) => {
    //   if (response.data.length) {
    //     response.data.forEach((el) => {
    //       this.planos.push({
    //         label: el.nomePacote,
    //         value: el.codPacote,
    //       });
    //     });
    //   }
    // });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.cadastroNaoAssociado /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  background: white;
  padding: 2rem;
  border-radius: 6px;
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
        height: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
      button {
        padding-left: 1.4rem;
        padding-right: 1.4rem;
      }
    }
  }
}
.visibility {
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 1rem;
  cursor: pointer;
}
</style>
